import { useCallback, useEffect, useState } from 'react'

export function useCountdown() {
  const [secondsLeft, setSecondsLeft] = useState(0)

  useEffect(() => {
    if (secondsLeft <= 0) return

    const timeout = setTimeout(() => setSecondsLeft(current => current - 1), 1000)

    return () => clearTimeout(timeout)
  }, [secondsLeft])

  const start = useCallback((seconds: number) => setSecondsLeft(seconds), [])

  return { secondsLeft, start }
}
